import * as Constantes from '../../shared/constants';

import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { IArtPreparacion } from 'src/app/interfaces/artPreparacion';
import { ICampanya } from 'src/app/interfaces/campanya';

// Interfaces 

// Servicios
import { PreparacionesService } from 'src/app/services/datos/preparaciones.service';
import { UicService } from 'src/app/services/datos/uic.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { environment } from 'src/environments/environment';

//librerías
import Swal from 'sweetalert2';

interface IPreparacionesAgrupadas {
  [uic: string]: IArtPreparacion[];
}

@Component({
  selector: 'app-prepara-recoge',
  templateUrl: './prepara-recoge.component.html',
  styleUrls: ['./prepara-recoge.component.scss']
})
export class PreparaRecogeComponent implements OnInit {

  //Usar constantes en el template
  Constantes = Constantes;

  recogida_cod: string = '';
  public preparacionesList: IArtPreparacion[] = [];
  preparacionesListRESUMEN: IArtPreparacion[] = [];
  public totalUbis: number = 0;
  public campanya: ICampanya = {};
  public cliente: any = {};

  registroActual: any = {
    estado: Constantes.ESTADO_PREPARACION_PENDIENTE,
    ubiFormat: '',
    ubicacion: 'xxx',
    uic: null,
    cant_recogida: 0,
    cant_alCarro: 1,
    saltar: ''
  }; // Almacena el registro actual.


  currentIndex: number = 0; // Índice del registro actual en el array 
  public uic: string | null = ''; // Identificador de carrito

  public preparacionesAgrupadas: IPreparacionesAgrupadas = {};
  public cajasEscogidas: boolean = false;

  public cantidadInfo: string = '';


  public formRec: FormGroup = new FormGroup({});

  public enviado: boolean = false;
  public loading: boolean = false;

  public cajasRecogidas: any[] = [];
  private pendingCajasInfo: any = null;

  public fotoDir: string = environment.fotoDir;
  public imgResized: string = localStorage.getItem('imgResized') || '/resize/';

  constructor(
    private prepracionSrv: PreparacionesService,
    private fb: FormBuilder,
    private notificacionesSrv: NotificacionesService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private uicSrv: UicService
  ) { }




  ngOnInit(): void {

    this.registroActual.cant_recogida = 0;

    this.formRec = this.fb.group({
      uic: ['', Validators.required],
      ubicacion: ['', Validators.required],
      ean: ['', Validators.required],
      cant_alCarro: [1, [Validators.required, this.cantidadValida.bind(this)]],
      cant_cajas: [''],
      cant_cajas_unidades: [''],
      saltar: ['Falta stock']
    })

    // Suscribirse a los parámetros de la url, envían un parámetro, cargar los datos 
    this.activatedRoute.params.subscribe(({ recogida_cod }) => {
      this.recogida_cod = recogida_cod;
      this.cargaPreparacionList();
      this.cargaPreparacionAgrupadaList();  // Actualiza lista de carritos usados en esta preparación

      //  this.filtraMotivos();   // Filtrar motivos definitivos en preparacionesList
    })


    // Suscribirse a los cambios de ubicacion en el form
    this.formRec?.get('ubicacion')?.valueChanges.subscribe(async (valUbicacion) => {
      if (valUbicacion === this.registroActual.ubicacion) {
        // Pasar el foco a ean
        await this.pausar(400); // Pausa durante 0.2 segundos
        const elementoSiguiente = document.getElementById('ean');
        if (elementoSiguiente) {
          elementoSiguiente.focus();
        }
      }
    });


    // Suscribirse a los cambios de cantidad para resetear el estado de cajas escogidas
    this.formRec?.get('cant_alCarro')?.valueChanges.subscribe(() => {
      this.cajasEscogidas = false;
    });


  }


  // Check cant_cajas y cant_cajas_unidades

  cant_cajasOut() {
    // Validar cajas
    this.cantidadInfo = '';
    const valCajas = Number(this.formRec.get('cant_cajas')?.value) || 0;
    const valCajasUnidades = Number(this.formRec.get('cant_cajas_unidades')?.value) || 0;
    if (valCajas <= 0) {
      this.formRec.get('cant_cajas')?.setErrors({ cantidadInvalida: true });
      return;
    }

    if (valCajasUnidades <= 0) {
      this.formRec.get('cant_cajas_unidades')?.setErrors({ cantidadInvalida: true });
      return;
    }

    // Si entran cajas, validar con un swal 
    if (valCajas > 0) {
      Swal.fire({
        html: '¿Estás seguro de que quieres recoger cajas? <br> ' + valCajas + ' Cajas con ' + valCajasUnidades + ' artículos : <h2 class="text-info">' + (valCajas * valCajasUnidades).toLocaleString('de-DE') + ' Unidades</h2>',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, estoy seguro',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          console.log('__Total entrada: ', valCajas * valCajasUnidades);

          // Almacenar temporalmente los datos para guardarlos en el array solo si el updateRec() tiene éxito
          this.pendingCajasInfo = {
            camp_cod: this.campanya.camp_cod,
            recogida_cod: this.recogida_cod,
            uic: this.registroActual.uic,
            id_articulo: this.registroActual.id_articulo,
            ean: this.registroActual.ean,
            cajas: valCajas,
            cant_cajas_unidades: valCajasUnidades
          };

          this.formRec.get('cant_alCarro')?.setValue(valCajas * valCajasUnidades);
          this.formRec.get('cant_cajas')?.setValue('');
          this.formRec.get('cant_cajas_unidades')?.setValue('');
          this.cajasEscogidas = true;
          this.cantidadInfo = valCajas + ' Cajas con ' + valCajasUnidades + ' artículos : <b> &nbsp; ' + (valCajas * valCajasUnidades).toLocaleString('de-DE') + '</b> &nbsp; Unidades';
        }
      });
    }

    this.focoEan();
    return;
  }


  cancel_cant_cajas() {
    this.cajasEscogidas = false;
    this.cantidadInfo = '';
    this.pendingCajasInfo = null;
    this.formRec.get('cant_alCarro')?.setValue(1);
    this.limpiaCajas();
    this.focoEan();
  }

  // Limpia el valor de cant_cajas y cant_cajas_unidades
  limpiaCajas() {
    this.formRec.get('cant_cajas')?.setValue(null);
    this.formRec.get('cant_cajas_unidades')?.setValue(null);
  }

  focoEan() {
    // Pasa el foco al campo EAN
    console.log('__focoEan()');
    setTimeout(() => {
      const eanElement = document.getElementById('ean');
      if (eanElement) {
        eanElement.focus();
      }
    }, 100);
    return;
  }







  // Método para controlar EAN Enter key press:

  async onEanEnter(event: any) {
    if (event.key !== 'Enter') return;

    event.preventDefault();

    const valEan = this.formRec.get('ean')?.value?.trim();

    // Validaciones 
    if (!valEan) {
      this.formRec.get('ean')?.setErrors({ required: true });
      return;
    }

    // if (valEan.length > 13) {
    //   this.formRec.get('ean')?.setErrors({ formatoIncorrecto: true });
    //   return;
    // }

    if (valEan !== this.registroActual.ean) {
      this.formRec.get('ean')?.setErrors({ noCoincide: true });
      this.notificacionesSrv.aviso('error', 'El EAN no coincide con el esperado');
      return;
    }


    // Obtener cantidad 
    const valCantPillada = Number(this.formRec.get('cant_alCarro')?.value) || 0;

    if (valCantPillada <= 0) {
      this.formRec.get('cant_alCarro')?.setErrors({ cantidadInvalida: true });
      return;
    }


    // Usar números
    const cantRecogida = Number(this.registroActual.cant_recogida) || 0;
    const cantReserva = Number(this.registroActual.cant_reserva) || 0;
    const stockUbi = Number(this.registroActual.stockUbi) || 0;

    // Validar cantidad
    if (cantRecogida + valCantPillada > cantReserva) {
      this.formRec.get('cant_alCarro')?.setErrors({ cantidadInvalida: true });
      return;
    }

    // Actualizar registro de forma síncrona
    this.registroActual.cant_recogida = cantRecogida + valCantPillada;
    this.registroActual.stockUbi = stockUbi - valCantPillada;
    this.registroActual.cant_alCarro = valCantPillada;
    this.registroActual.estado = this.Constantes.ESTADO_PREPARACION_UIC_EMPEZADA;

    // Limpiar EAN y cantidad para siguiente lectura
    this.formRec.patchValue({ ean: '', cant_alCarro: 1 }, { emitEvent: false });
    this.cajasEscogidas = false;
    this.cantidadInfo = '';
    this.formRec.get('cant_cajas')?.setValue(null);
    this.formRec.get('cant_cajas_unidades')?.setValue(null);

    try {
      // Actualización en background
      await this.updateRec();

      // Verificar si está completado
      if (this.registroActual.cant_recogida >= cantReserva) {
        this.registroActual.estado = this.Constantes.ESTADO_PREPARACION_UIC_COMPLETADA;
        await this.updateRec();
        this.avanzar();
      }
    } catch (error) {
      console.error('Error actualizando registro:', error);
    }
  }


  cargaPreparacionList() {
    this.loading = true;

    const data = {
      recogida_cod: this.recogida_cod || null,
      todo: '0'
    };

    this.prepracionSrv.listRecogidaCod(data).subscribe(resp => {
      this.loading = false;
      console.log('__cargaPreparacionList() listaPreparaciones', resp);
      if (resp.error) this.notificacionesSrv.aviso('error', resp.mensaje);
      this.preparacionesList = resp.data;
      this.totalUbis = resp.totales.ubis;
      this.campanya = resp.totales.campanya;
      this.cliente = resp.totales.cliente;

      if (!this.totalUbis) {
        this.notificacionesSrv.aviso('error', `No se han encontrado recogidas para el código ${this.recogida_cod}`);
        this.router.navigate(['./pda']);
        return
      }

      //   this.formRec.patchValue({ ubicacion: null });
      this.cargarRegistro(0);

    })
  }

  enviar() {

    this.enviado = true;

    if (this.formRec.invalid) {
      console.log("ERRORES:", this.formRec);
      return;
    }
    // Todo ok, enviar al BackEnd
    console.log('__enviar() formRec.value', this.formRec.value);
  }



  // Modificar registro (estado y cantidad recogida) async/await
  async updateRec(): Promise<void> {
    console.log('__updateRec registroActual', this.registroActual);

    // Guardar valores originales para posible rollback
    const valoresOriginales = {
      cant_recogida: this.registroActual.cant_recogida,
      stockUbi: this.registroActual.stockUbi,
      cant_alCarro: this.registroActual.cant_alCarro
    };

    try {
      const resp = await this.prepracionSrv.updatePrep(this.registroActual).toPromise();
      console.log('__updateRec resp', resp);

      if (resp!.error) {
        // Rollback automático de los contadores
        this.rollbackContadores(valoresOriginales);
        this.notificacionesSrv.aviso('error', resp!.mensaje);
        throw new Error(resp!.mensaje);
      }

      // Si todo está bien, forzar la asignación del UIC al cliente
      await this.updateUicCliente();

      // Si había información de cajas pendiente, ahora que el registro se ha guardado correctamente, lo añadimos al historial de la pantalla y lo enviamos al BackEnd
      if (this.pendingCajasInfo) {
        this.cajasRecogidas.push({ ...this.pendingCajasInfo });
        this.pendingCajasInfo = null;

        const data = {
          cajasRecogidas: this.cajasRecogidas
        };

        try {
          console.log('__updatePrepCajas data', data);
          const resp = await this.prepracionSrv.updatePrepCajas(data).toPromise();
          console.log('__updatePrepCajas resp', resp);

          if (resp!.error) {
            // Rollback automático de los contadores
            this.rollbackContadores(valoresOriginales);
            this.notificacionesSrv.aviso('error', resp!.mensaje);
            throw new Error(resp!.mensaje);
          }

        } catch (error) {
          // En caso de cualquier error, hacer rollback
          this.rollbackContadores(valoresOriginales);
          throw error;
        }
      }

    } catch (error) {
      // En caso de cualquier error, hacer rollback
      this.rollbackContadores(valoresOriginales);
      throw error;
    }
  }



  // Método auxiliar para el rollback de contadores
  private rollbackContadores(valoresOriginales: any): void {
    this.registroActual.cant_recogida = valoresOriginales.cant_recogida;
    this.registroActual.stockUbi = valoresOriginales.stockUbi;
    this.registroActual.cant_alCarro = valoresOriginales.cant_alCarro;
  }


  cantidadValida(control: { value: any; }) {
    // Validar la cantidad recogida
    const valor = control.value;
    const cantReserva = this.registroActual.cant_reserva;

    if (isNaN(valor) || valor < 1 || valor > cantReserva) {
      return { cantidadInvalida: true };
    }

    return null;
  }



  //// AUX  ///



  get f() {
    return this.formRec.controls;
  }

  cargarRegistro(index: number): void {
    // Carga el registro actual según el índice proporcionado 
    if (index >= 0 && index < this.preparacionesList.length) {
      this.registroActual = this.preparacionesList[index];
      this.registroActual.uic = null // Obligar a pedir el carro
      this.currentIndex = index;
      this.cajasEscogidas = false;
      this.pendingCajasInfo = null;
    }

    this.prepracionSrv.getPrepCajas(this.recogida_cod)
      .subscribe(resp => {
        console.log('__getPrepCajas resp', resp);
        if (resp.error) this.notificacionesSrv.aviso('error', resp.mensaje);
        this.cajasRecogidas = resp.data;
      })

    console.log('__cargarRegistro() registroActual', this.registroActual);
    console.log('__cargarRegistro() this.preparacionesList', this.preparacionesList);
  }


  async onUicEnter(event: any) {
    // ENTER en el input uci

    if (event.key === 'Enter') {
      event.preventDefault(); // Evita el comportamiento predeterminado del Enter (submit del formulario)
      this.enviado = true;

      // Validar el formato del UIC
      const uicControl = this.formRec.get('uic')?.value.toUpperCase();
      this.formRec.patchValue({ uic: uicControl });
      const uicRegex = /^UIC\d{10}$/;  // 'UIC' seguido de 10 dígitos
      console.log('onUicEnter', uicControl);
      console.log('__formRec', this.formRec);

      if (!uicRegex.test(uicControl)) {
        this.formRec.get('uic')?.setErrors({ formatoIncorrecto: true });
        return;
      }

      // Validar UIC
      const data = {
        uic: uicControl,
        preparacion: this.registroActual
      }
      this.uicSrv.valUicPreparacion(data).subscribe(async resp => {
        console.log('__valUicPreparacion resp', resp);
        if (resp.error) {
          this.notificacionesSrv.aviso('error', resp.mensaje);
          this.formRec.get('uic')?.setErrors({ apiError: resp.mensaje });
          return;
        }

        // validar estado
        if (resp.data.estado === Constantes.ESTADO_UIC_CADUCADO) {
          this.formRec.get('uic')?.setErrors({ apiError: "Este UIC está marcado como CADUCADO" });
          return;
        }
        if (resp.data.estado === Constantes.ESTADO_UIC_EN_PREPARACION) {
          this.formRec.get('uic')?.setErrors({ apiError: "Este UIC está marcado como en PREPARACIÓN" });
          return;
        }
        if (resp.data.estado === Constantes.ESTADO_UIC_LLENO) {
          this.formRec.get('uic')?.setErrors({ apiError: "Este UIC está marcado como CARRO LLENO" });
          return;
        }


        // validar camp_cod
        if (resp.data.camp_cod && resp.data.camp_cod != this.registroActual.camp_cod) {
          this.formRec.get('uic')?.setErrors({ apiError: "Este UIC se está utilizando en la campaña " + resp.data.camp_cod });
          return;
        }

        // validar cliente
        if (resp.data.id_cliente) {
          if (this.registroActual.id_cliente !== resp.data.id_cliente) {
            this.formRec.get('uic')?.setErrors({ apiError: `Este UIC está asignado a ${resp.data.cliNombre}` });
            return;
          }
        }


        // Todo ok, Añadir el id_uic al registro
        this.registroActual.id_uic = resp.data.id;
        this.notificacionesSrv.aviso('success', resp.mensaje);


        // Formato correcto
        this.registroActual.uic = uicControl;
        await this.pausar(500); // Pausa 1/2 segundo

        // pasa el foco al siguiente campo
        const elementoSiguiente = document.getElementById('ubicacion');
        console.log('elementoSiguiente ', elementoSiguiente)
        if (elementoSiguiente) {
          elementoSiguiente.focus();
        }
      });
    }
  }





  async onUbicacionEnter(event: any) {
    // ENTER en el input ubicacion

    if (event.key === 'Enter') {
      event.preventDefault(); // Evita el comportamiento predeterminado del Enter (submit del formulario)

      // Validar ubicacion
      const valUbicacion = this.formRec.get('ubicacion')?.value;
      console.log('onUbicacionEnter', valUbicacion);

      if (valUbicacion !== this.registroActual.ubicacion) {
        this.enviado = true;
        this.formRec.get('ubicacion')?.setErrors({ noValido: true });
        return;
      }

      // valor correcto 
      await this.pausar(400); // Pausa durante 0.2 segundos
      return;

    }
  }

  saltaUic(inputElement: HTMLInputElement): void {
    // Disparar el evento "Enter" en el input 
    const enterEvent = new KeyboardEvent('keydown', {
      key: 'Enter',
      code: 'Enter',
      keyCode: 13,
      bubbles: true
    });

    // Disparar el evento "Enter" en el input
    inputElement.dispatchEvent(enterEvent);
  }



  saltaUbicacion() {
    // Acepta la ubucación propuesta
    Swal.fire({
      title: 'Aceptar ubicación',
      icon: 'question',
      html: `¿Estás seguro de aceptar la ubicación sin leerla?`,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Si',
    }).then((result) => {
      if (result.isConfirmed) {
        this.formRec.patchValue({
          ubicacion: this.registroActual.ubicacion
        })
      }
    })
  }


  saltaEan() {
    // Acepta el EAN propuesto
    Swal.fire({
      title: 'Aceptar EAN',
      icon: 'question',
      html: `¿Estás seguro de aceptar el código EAN del artículo sin leerlo?`,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Si',
    }).then((result) => {
      if (result.isConfirmed) {
        this.formRec.patchValue({
          ean: this.registroActual.ean
        })
        // Simular el evento Enter para continuar con el proceso
        const fakeEvent = {
          key: 'Enter',
          preventDefault: () => { }
        };
        this.onEanEnter(fakeEvent);
      }
    })
  }


  carroLlenoClick() {
    // Duplicar registro con un nuevo UIC
    this.prepracionSrv.carroLleno(this.registroActual.id)
      .subscribe(async resp => {
        console.log('__carroLlenoClick resp', resp);
        if (resp.error) {
          this.notificacionesSrv.aviso('error', resp.mensaje);
          return;
        }
        this.notificacionesSrv.aviso('success', resp.mensaje);
        window.location.reload();




        //   await this.pausar(500); // Pausa durante 0.5 segundos 

        // Cargar el nuevo array
        //  this.cargaPreparacionList();
        // this.registroActual.uic = '';
        //  this.registroActual.cant_recogida = 0;
        //  this.uic = null;

        //   this.formRec.patchValue({
        //     cant_recogida: this.registroActual.cant_recogida,
        //     cant_alCarro: 1,
        //  / uic: this.uic,
        //     ean: '',
        //     estado: this.registroActual.estado,
        //     foto: this.registroActual.foto,
        //     id_articulo: this.registroActual.id_articulo,
        //     sku: this.registroActual.sku,
        //     ubicacion: ''
        //   })
      })

  }



  saltarArticuloClick() {
    this.registroActual.saltar = this.formRec.get('saltar')?.value;

    console.log('__saltarArticuloClick()')
    console.log('currentIndex ', this.currentIndex)
    console.log('registroActual ', this.registroActual)

    this.prepracionSrv.saltarArticulo(this.registroActual)
      .subscribe(async resp => {
        console.log('__saltarArticuloClick resp', resp);
        if (resp.error) {
          this.notificacionesSrv.aviso('error', resp.mensaje);
          return;
        }

        // Filtrar motivos definitivos en preparacionesList
        // this.filtraMotivos();

        // Avanzar al siguiente 
        if (this.currentIndex >= this.preparacionesList.length - 1) {
          this.currentIndex = -1;// volver al primero?
        }
        this.avanzar();
      });


  }





  async avanzar(): Promise<void> {
    // Avanza al siguiente registro
    this.uic = this.registroActual.uic;
    const prevUbi = this.registroActual.ubicacion; // Guardar ubicación previa
    const id_uic = this.registroActual.id_uic;     // Guardar id_uic previo

    console.log('__avanzar()')

    // Quedan preparaciones pendientes?
    if (this.currentIndex >= this.preparacionesList.length - 1) {
      this.notificacionesSrv.aviso('success', `Preparación lista, ${this.preparacionesList.length} ubicaciones recogidas`);
      //  this.router.navigate(['./pda']);
      this.router.navigate([`./pda/prepara_detall/${this.recogida_cod}`]);
      return
    }

    this.currentIndex++;
    this.cargarRegistro(this.currentIndex);

    const esMismaUbi = (this.registroActual.ubicacion === prevUbi);

    if (esMismaUbi) {
      // Si es la misma ubicación, restaurar el UIC y el id_uic 
      // (evitando el reset a null que hace cargarRegistro)
      this.registroActual.uic = this.uic;
      this.registroActual.id_uic = id_uic;
      this.notificacionesSrv.aviso('success', `Misma ubicación, nuevo artículo`);
    }


    this.formRec.patchValue({
      cant_recogida: this.registroActual.cant_recogida,
      cant_alCarro: 1,
      uic: this.uic,
      ean: '',
      estado: this.registroActual.estado,
      foto: this.registroActual.foto,
      id_articulo: this.registroActual.id_articulo,
      sku: this.registroActual.sku,
      ubicacion: esMismaUbi ? this.registroActual.ubicacion : '',
      saltar: this.registroActual.saltar
    })

    // pasa el foco al siguiente campo

    await this.pausar(400); // Pausa durante 0.4 segundos 

    if (esMismaUbi) {
      this.focoEan();
    } else {
      const elementoSiguiente = document.getElementById('ubicacion');
      if (elementoSiguiente) {
        elementoSiguiente.focus();
      }
    }


    this.cargaPreparacionAgrupadaList();  // Actualiza lista de carritos usados en esta preparación
    this.cajasEscogidas = false;
    this.pendingCajasInfo = null;
    console.log('__avanzar registroActual', this.registroActual);
  }



  buscaUbicacionAlternativa() {
    // Buscar este artículo en diferente ubicación

    Swal.fire({
      title: 'Ubicación alternativa',
      icon: 'question',
      html: `¿Quieres buscar este atrículo en otra ubicación?`,
      input: 'select',
      inputOptions: {
        'Nueva ubicación, falta Stock': 'Falta Stock',
        'Nueva ubicación Stock dañado': 'Stock Dañado',
        'Nueva ubicación Sin acceso a Stock': 'Sin Acceso a Stock',
        'Nueva ubicación, Otras causas': 'Otros'
      },
      inputPlaceholder: 'Selecciona motivo...',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Si',
    }).then((motivo) => {
      if (motivo.isConfirmed) {
        // Llamar al servicio para buscar nueva ubicación con el motivo
        this.registroActual.saltar = motivo.value;
        this.loading = true;
        this.prepracionSrv.buscaUbiAlternativa(this.registroActual)
          .subscribe(async resp => {
            this.loading = false;
            console.log('__buscaUbicacionAlternativa()', resp);

            if (resp.error) {
              this.notificacionesSrv.aviso('error', resp.mensaje);
              return;
            }
            if (resp.totales && resp.totales.salidaTipo === 'B') {
              this.notificacionesSrv.aviso('warning', resp.mensaje);
            }
            if (resp.totales && resp.totales.salidaTipo === 'C') {
              this.notificacionesSrv.aviso('success', resp.mensaje);
            }

            // Cargar las nuevas preparaciones
            this.cargaPreparacionList();
            await this.pausar(400); // Pausa durante 0.2 segundos
            this.cargarRegistro(0);

            // conservar uic en el form            
            await this.pausar(400); // Pausa durante 0.2 segundos
            const fakeEvent = { key: 'Enter', preventDefault: () => { } };  // Simula un objeto de evento Enter
            this.onUicEnter(fakeEvent);

          });

      }
    })
  }


  cerrarPreparacion() {
    // Marcar los que faltan como estado '8'
    Swal.fire({
      title: 'Cerrar recogida NO acabada',
      icon: 'warning',
      html: `¿Quieres cerrar esta recogida?`,
      input: 'select',
      inputOptions: {
        'Cierre de recogida por falta de stock': 'Falta stock',
        'Cierre de recogida por stock dañado': 'Stock dañado',
        'Cierre de recogida por stock NO accesible': 'Sin acceso a stock',
        'Cierre de recogida por otras causas': 'Otras causas'
      },
      inputPlaceholder: 'Selecciona motivo...',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Si',
    }).then((motivo) => {
      if (motivo.isConfirmed) {
        console.log('__cerrarPreparacion motivo: ', motivo)

        // Llamar al servicio para cerrar preparación con el motivo
        this.registroActual.saltar = motivo.value;
        this.loading = true;
        this.prepracionSrv.cerrarPreparacion(this.registroActual)
          .subscribe(resp => {
            this.loading = false;
            console.log('__cerrarPreparacion() resp', resp);
            if (resp.error) {
              this.notificacionesSrv.aviso('error', resp.mensaje);
              return;
            }

            this.notificacionesSrv.aviso('success', resp.mensaje);
            this.router.navigate([`./pda/prepara_detall/${this.recogida_cod}`]);
            return
          });
      }
    })

  }


  /// AUX ///

  filtraMotivos() {
    // Filtrar los motivos definitivos en preparacionesList
    this.preparacionesList = this.preparacionesList.
      filter(item => item.saltarDefinitivo !== '1'
      );
  }

  limpiaUic() {
    // Limpia el campo uic del formulario  
    this.formRec.get('uic')?.setValue('');
  }


  pausar(milisegundos: number): Promise<void> {
    return new Promise((resolve) => {
      setTimeout(resolve, milisegundos);
    });
  }


  volverClick() {
    this.router.navigate(['./pda']);
    return
  }


  get cajasCalculadas(): number {
    // El cliente puede tener la opción de recoger cajas?
    if (this.cliente.confRecogidaCajas === 'N') return 0;

    // Si es campaña 1 a 1, no se pueden calcular cajas, ya se muestra cant_cajas
    if (this.campanya.campanyaTipo === '1 a 1') return 0;

    // Si no hay unidades por caja, no se pueden calcular cajas
    if (!this.registroActual.unidadesCaja || this.registroActual.unidadesCaja <= 0) return 0;

    // Calcular cajas
    const pendiente = (this.registroActual.cant_reserva || 0) - (this.registroActual.cant_recogida || 0);
    return Math.floor(pendiente / this.registroActual.unidadesCaja);
  }


  enviaCajas() {
    console.log('__enviaCajas() this.registroActual', this.registroActual);

    if (this.cajasEscogidas) {
      this.formRec.patchValue({ cant_alCarro: 1 });
      this.cajasEscogidas = false;
      this.focoEan();
      return;
    }

    const totalUnidades = this.cajasCalculadas * this.registroActual.unidadesCaja;
    if (totalUnidades > 0) {
      this.formRec.patchValue({ cant_alCarro: totalUnidades });
      this.cajasEscogidas = true;
      this.focoEan();
    }
  }



  // Asigna un UIC al cliente
  updateUicCliente() {
    this.uicSrv.updateUicCliente(this.registroActual).subscribe(resp => {
      console.log('__asignarClinete resp', resp);

      this.cargaPreparacionAgrupadaList();    // Actualiza la lista de carros con sus contenidos para esta preparación (para la vista al pié de la preparación)

      return;
    });
  }


  /// Resumen de Carritos preparación Al pié ///


  public getPreparacionesAgrupadasKeys(): string[] {
    // Actualiza la lista de carros con sus contenidos para esta preparación
    // Getter del key
    return Object.keys(this.preparacionesAgrupadas);
  }

  cargaPreparacionAgrupadaList() {
    this.loading = true;


    const data = {
      recogida_cod: this.recogida_cod || null,
      todo: '1'
    };

    this.prepracionSrv.listRecogidaCod(data).subscribe(resp => {
      this.loading = false;
      console.log('__cargaPreparacionAgrupadaList() resp', resp);
      if (resp.error) this.notificacionesSrv.aviso('error', resp.mensaje);
      this.preparacionesListRESUMEN = resp.data;

      this.preparacionesAgrupadas = this.agruparPorUIC();
      console.log('__cargaPreparacionList() preparacionesAgrupadas', this.preparacionesAgrupadas);

    })
  }

  private agruparPorUIC(): { [key: string]: any[] } {
    const agrupadas: { [key: string]: any[] } = {};

    for (const preparacion of this.preparacionesListRESUMEN) {
      let uic = preparacion.uic;

      // Si uic está vacío, asigna una clave especial
      if (!uic) {
        uic = 'Incidencias';
      }

      if (!agrupadas[uic]) agrupadas[uic] = [];
      agrupadas[uic].push(preparacion);
    }


    // Obtiene las claves (UIC) y las ordena alfabéticamente
    const uicKeys = Object.keys(agrupadas).sort();

    // Devielve el objeto ordenado por UIC 
    const agrupadasOrdenadas: { [key: string]: any[] } = {};
    for (const key of uicKeys) {
      agrupadasOrdenadas[key] = agrupadas[key];
    }

    return agrupadasOrdenadas;

  }

  // Formatear ubicación con grupos 2, 3 y 4 destacados
  formatUbicacion(ubicacion: string | null): string {
    console.log('__formatUbicacion() ubicacion', ubicacion);
    if (!ubicacion) return '';
    const masked = ubicacion.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1.$2.$3.$4.$5.$6');
    if (!masked) return '';
    const partes = masked.split('.');

    console.log('__formatUbicacion() partes', partes);

    // grupos 2, 3 y 4 (índices 1, 2, 3)
    return partes.map((p, i) => {
      console.log('__formatUbicacion() p', p);
      console.log('__formatUbicacion() i', i);
      return (i >= 1 && i <= 3)
        ? `<span class="ubi-highlight">${p}</span>`
        : p;
    }).join('.');
  }



}
